<template>
  <div class="ss-checkbox">
    <input :id="id" v-model="state"
           type="checkbox"
           :disabled="disabled"
           @change="toggle">
    <label :for="id" :title="title"
           :class="{
             'no-content': $scopedSlots[`default`]
           }">
      <slot />
    </label>
  </div>
</template>

<script>
export default {
  name: `ss-checkbox`,
  props: {
    id: {
      type: String,
      required: false,
      default: null,
    },
    value: {
      type: null,
      required: false,
      default: null,
    },
    checked: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: function () {
    return {
      state: !!(this.value ?? this.checked), // try our best
    };
  },
  watch: {
    value(new_value) {
      this.state = new_value;
    },
  },
  methods: {
    toggle() {
      for (const ev of [`input`, `change`]) {
        this.$emit(ev, this.state);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:color";
@use "sass:map";

@use "~AssetsSass/_variables" as *;

.ss-checkbox {
	position: relative;
  display: inline-block;

	label {
		cursor: pointer;

		&::before {
			content: "";
			margin-right: 0.7em;
			width: 5px;
			height: 10px;
			border-width: 0 2px 2px 0 !important;
			transform: rotate(45deg);
			display: inline-block;
			margin-left: 0.45em;
		}

    &.no-content {
      &::before {
        margin-right: 0.45em;
      }
    }

		&::after {
			content: "";
			display: inline-block;
			width: 1.25em;
			height: 1.25em;
			border: 1px solid color.adjust(map.get($ss-theme, 'stonewash-grey'), $lightness: -2%, $space: hsl);
			border-radius: 3px;
			position: absolute;
			top: 0.2em;
			left: 0;
		}
	}

	input {
		&[type='checkbox'] {
			display: none;
		}

		&:checked~label::before {
			border: 1px solid map.get($ss, 'primary');
		}

    &:disabled~label::before {
      border-color: color.adjust(map.get($ss-adds, 'light-grey'), $lightness: -12%, $space: hsl);
    }
	}
}
</style>
